import {
  UPDATE_META_PROP_DATA,
  UPDATE_SELECTED_TAG,
  UPDATE_DYNA_PROP_VALUES,
  UPDATE_STAT_PROP_VALUES,
  UPDATE_TAGS_CATS_LIST,
  UPDATE_SELECTED_PROP_VALUES,
  UPDATE_SELECTED_SCHEDULE,
  SHOW_TAGS_CATS_LIST,
  SHOW_META_PROP_TAG_LIST,
  UPDATE_SHOW_ALL,
  UPDATE_SHOW_SELECTION,
  UPDATE_ADDITIONAL_TABS,
  UPDATE_SELECTED_GUID,
} from "../constants/Constants";

const initialState = {
  tagSlected: false,
  selectedTag: "",
  isMetaPropDataLoaded: false,
  elementWithProperties: [],
  categories: [],
  dynaPropValues: [],
  statPropValues: [],
  elemTagsCatsList: [],
  selectedPropValues: [],
  selectedSchedule: "",
  showElemTagCatList: false,
  showMetaPropTagList: false,
  showAll: false,
  showSelection: false,
  allowAdditionalTabs: true,
};

const metaPropReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_META_PROP_DATA:
      return {
        ...state,
        elementWithProperties: action.payload[0],
        categories: action.payload[1],
        isMetaPropDataLoaded: action.payload[2],
      };
    case UPDATE_SELECTED_TAG:
      return {
        ...state,
        selectedTag: action.payload,
        tagSlected: true,
      };
    case UPDATE_SELECTED_GUID:
      return {
        ...state,
        selectedGuId: action.payload,
        guIdSelected: true,
      };
    case UPDATE_DYNA_PROP_VALUES:
      return {
        ...state,
        dynaPropValues: action.payload,
      };
    case UPDATE_STAT_PROP_VALUES:
      return {
        ...state,
        statPropValues: action.payload,
      };
    case UPDATE_TAGS_CATS_LIST:
      return {
        ...state,
        elemTagsCatsList: action.payload,
      };
    case UPDATE_SELECTED_PROP_VALUES:
      return {
        ...state,
        selectedPropValues: action.payload,
      };
    case UPDATE_SELECTED_SCHEDULE:
      return {
        ...state,
        selectedSchedule: action.payload,
      };
    case SHOW_TAGS_CATS_LIST:
      return {
        ...state,
        showElemTagCatList: action.payload,
      };
    case SHOW_META_PROP_TAG_LIST:
      return {
        ...state,
        showMetaPropTagList: action.payload,
      };
    case UPDATE_SHOW_ALL:
      return {
        ...state,
        showAll: action.payload,
      };
    case UPDATE_SHOW_SELECTION:
      return {
        ...state,
        showSelection: action.payload,
      };
    case UPDATE_ADDITIONAL_TABS:
      return {
        ...state,
        allowAdditionalTabs: action.payload,
      };

    default:
      return state;
  }
};

export default metaPropReducer;
